import React from "react";
import "./LandingPage.css";

function LandingPage({ questions, startQuiz }) {
  // Extract unique categories
  const categories = [...new Set(questions.map(q => q.category))];

  return (
    <div className="landing-container">
      <h1>What do you know about Katniss?</h1>
      {categories.map((cat, index) => (
        <button
          key={index}
          onClick={() => startQuiz(cat)}
          className="category-button"
        >
          {cat}
        </button>
      ))}
    </div>
  );
}

export default LandingPage;
